'use strict';

var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function SvgProfileCircle(props) {
    return (React__default.default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", ...props },
        React__default.default.createElement("defs", null,
            React__default.default.createElement("path", { d: "M5.996 12C9.273 12 12 9.279 12 6S9.266 0 5.989 0C2.719 0 0 2.721 0 6s2.727 6 5.996 6zm0-4c-1.701 0-3.016.572-3.633 1.242A4.848 4.848 0 011.144 6c0-2.706 2.148-4.87 4.845-4.87A4.858 4.858 0 0110.863 6a4.87 4.87 0 01-1.218 3.242C9.028 8.572 7.705 8 5.996 8zm0-.981c1.122.014 2.006-.945 2.006-2.201 0-1.182-.884-2.156-2.006-2.156-1.114 0-2.006.974-1.998 2.156.007 1.256.876 2.186 1.998 2.2z", id: "Profile-circle__svg__a" })),
        React__default.default.createElement("g", { fill: "none", fillRule: "evenodd" },
            React__default.default.createElement("path", { d: "M0 0h16v16H0z" }),
            React__default.default.createElement("g", { transform: "translate(2 2)" },
                React__default.default.createElement("path", { d: "M0 0h12v12H0z" }),
                React__default.default.createElement("use", { fill: "currentColor", xlinkHref: "#Profile-circle__svg__a" })))));
}

module.exports = SvgProfileCircle;
//# sourceMappingURL=ProfileCircle.js.map
